import React, { FC } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { VideoSection } from '../videoSection/VideoSection';
import { useUser } from '../../hooks/useUser';
import { isBrand } from '../../utils';

/**
 * §07 — the expert-page embed: one VideoSection for both roles, browse grid,
 * expert row suppressed (redundant here), inline detail via ?video= — brands
 * no longer get navigated off the profile.
 */
const ExpertVideosSection: FC = () => {
  const { role, brand } = useUser();
  const brandUser = isBrand(role);
  const brandId = brandUser && Array.isArray(brand) ? brand[0]?.id : undefined;

  return (
    <VideoSection
      brandId={brandId || undefined}
      defaultView="grid"
      features={{
        sort: true,
        filters: true,
        nonProject: brandUser ? 'probe' : 'always',
        inlineDetail: true,
      }}
      suppressExpertRow
      isExpertVideos
      excludeFilterKeys={['proId']}
      emptyTitle="No videos with this expert yet"
      emptyBody="When a video featuring this expert is published, it shows up here."
      detailContainerClassName="!py-0"
    />
  );
};

/** "View all" — the same query on the full videos page, proId carried along. */
export const ExpertVideosViewAll: FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { role } = useUser();
  const proId = searchParams.get('proId');
  if (!proId) return null;
  const target = isBrand(role) ? `/videos/tdc?proId=${proId}` : `/videos?proId=${proId}`;
  return (
    <button
      type="button"
      onClick={() => navigate(target)}
      className="text-accent-text font-bold hover:underline"
      style={{ fontSize: 13 }}
    >
      View all
    </button>
  );
};

export default ExpertVideosSection;
